<template>
    <div class="pay-ment-box">
        <div class="pay-ment">
            <Breadcrumb :crumb="crumb" bgcolor="#fff"></Breadcrumb>
            <div class="pay-code">
                <div class="tips-box flex align-center justify-between">
                    <div class="">
                        <div class="tips text-333">请及时付款，以便订单尽快处理！</div>
                        <div class="tips text-999">
                            请在 <span class="text-red">30分钟</span>内付款，否则交易会被取消
                        </div>
                    </div>
                    <div class="pay-price">
                        实付: <span class="text-red">￥{{Number(total).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="code-box">
                    <div class="code">
                        <div class="qrcode">
                            <canvas
                                    ref="c"
                                    id="qrccode-canvas"
                                    style="width:100%;height: 100%;"
                            ></canvas>
                        </div>
                    </div>
                    <img
                            v-if="['alipay'].includes(payType)"
                            src="../assets/images/pay/alipay-pay.png"
                            style="width: 180px;height: 161.47px;"
                    />
                    <img
                            v-if="['wechat'].includes(payType)"
                            src="../assets/images/pay/wechat-pay.png"
                            style="width: 200px; height: 250px;"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getPayStatus} from '@/api'
    import Breadcrumb from "@/components/Breadcrumb.vue";

    let QRCode = require("qrcode");
    export default {
        name      : "Payment",
        components: {
            Breadcrumb
        },
        data() {
            return {
                crumb      : [
                    {
                        title: "付款方式",
                        path : "Paytype"
                    }
                ],
                payType    : "",
                total      : 0,
                pay_id     : 0,
                timeHandler: 0
            };
        },
        created() {
            let that     = this
            this.payType = this.$route.params.type;
            this.total   = this.$route.params.total;
            this.pay_id  = this.$route.params.pay_id;
            setTimeout(() => {
                this.generate()
            }, 500)
            this.timeHandler = window.setInterval(() => {
                getPayStatus({pay_id: that.pay_id}).then(response => {
                    if (response.data.status > 0) {
                        window.clearInterval(that.timeHandler)
                        if (response.data.status == 9) {
                            that.$Notice.success({
                                title: '支付成功'
                            })
                            that.$router.replace({name: 'Center'});
                        } else {
                            that.$Notice.error({
                                title: '支付失败'
                            })
                            that.$router.replace({name: 'Center'});
                        }
                    }
                })
            }, 2000)
        },
        methods   : {
            generate() {
                if (!this.$route.params.url) {
                    this.$Notice.error({
                        title: '支付二维码获取失败'
                    })
                    return
                }
                QRCode.toCanvas(this.$refs.c, this.$route.params.url, error => {
                    if (error) {
                        console.log(error);
                    }
                });
            }
        },
        destroyed() {
            window.clearInterval(this.timeHandler)
        }
    };
</script>

<style lang="scss" scoped>
    .pay-ment-box {
        height: 550px;
        background: #f3f4f5;

        .pay-ment {
            padding-top: 20px;
            margin: auto;
            width: 1170px;
        }

        .pay-code {
            width: 1170px;
            height: 422px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            padding: 20px;

            .tips-box {
                width: 1130px;
                height: 72px;
                background: #fafafa;
                padding: 10px 20px;
            }

            .pay-price {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }

            .text-red {
                color: #be0505;
            }
        }

        .code-box {
            height: 330px;
            background: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;

            .code {
                text-align: center;
                font-size: 15px;
                color: #333333;
                margin-right: 60px;

                .qrcode {
                    width: 150px;
                    height: 150px;
                }
            }
        }
    }
</style>
